import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';

import ListItemText from '@material-ui/core/ListItemText';

import { BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

class MenuItem extends React.Component {
    render() {
        const { primary, intl, icon, last, active } = this.props;

        return (
            <div className={'flex_full_row margin_right_2' + (active ? ' bg_bluish' : '')}>
                <div
                    className={classNames(
                        'flex_full_row align_center menuItem64  margin_left_6',
                        active ? ' c_bluish bg_ligth_blue' : ' c_grey_blue bg_white',
                        last ? ' noshadow' : ' shadow_down_only',
                    )}
                >
                    <div
                        className={
                            'flex_full_row  padding_left_12 hand ' +
                            (active ? 'c_bluish bg_ligth_blue' : 'c_grey_blue bg_white')
                        }
                        onClick={this.props.onClick}
                        onKeyDown={this.props.onClick}
                    >
                        {icon && icon}
                        <div className={classNames('flex_full_row  margin_left_12')}>
                            <ListItemText
                                primary={intl.formatMessage({ id: primary })}
                                classes={{
                                    primary:
                                        'barlow_medium ' + (active ? 'c_bluish' : 'c_grey_blue'),
                                }}
                            />
                            <BlueRightArrowIcon color="primary" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MenuItem.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(MenuItem);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/MenuItem.js